/* import __COLOCATED_TEMPLATE__ from './language-selector.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();